import { useState } from "react";

import { Alert } from "../../../components/ui/Alert";
import { Button } from "../../../components/ui/Button";
import { ConfirmDialog } from "../../../components/ui/overlay/ConfirmDialog";
import { deleteMaterial } from "../api/materialApi";
import type { Material } from "../schemas/materialSchemas";

export function MaterialDeleteControl({
  material,
  onDeleted,
}: {
  material: Material;
  onDeleted: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  if (material.publicationStatus === "PUBLISHED") return null;

  const remove = async () => {
    setLoading(true);
    setError(undefined);
    try {
      await deleteMaterial(material);
      setOpen(false);
      onDeleted();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "刪除教材失敗。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-3">
      {error && <Alert variant="danger">{error}</Alert>}
      <Button variant="danger" onClick={() => setOpen(true)}>
        刪除教材
      </Button>
      <ConfirmDialog
        open={open}
        title="確認刪除教材"
        description="教材將從平台隱藏。此操作會留下稽核紀錄。"
        confirmLabel="確認刪除"
        destructive
        loading={loading}
        onConfirm={() => void remove()}
        onClose={() => !loading && setOpen(false)}
      />
    </div>
  );
}
